module.exports = __webpack_public_path__ + "img/bannerBG2.5bb9dc01.png";